import React from 'react'
import classNames from 'classnames'
import { FileListItem, Loading } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

interface OpenableFileListItemProps {
  fileName: string
  onOpen: () => void
  isOpening: boolean
}

export const OpenableFileListItem: React.FC<OpenableFileListItemProps> = ({
  fileName,
  onOpen,
  isOpening,
}) => {
  const { t } = useTranslation(['common'])

  const openUnlessOpening = () => {
    if (!isOpening) {
      onOpen()
    }
  }

  // FileListItem has no loading state of its own, so the overlay is placed over its thumbnail,
  // which relies on the thumbnail sitting at the top left and being --upload-thumbnail-l wide.
  // FileListItem does not read createdAt, and opening goes through onOpen, so the empty url only
  // leaves an image file's thumbnail without a preview.
  return (
    <div className="relative" aria-busy={isOpening}>
      <FileListItem
        file={{ fileName, url: '', createdAt: '' }}
        onClick={openUnlessOpening}
        onOpen={openUnlessOpening}
      />
      <div
        role="status"
        className={classNames(
          'absolute top-0 left-0 aspect-square w-[var(--upload-thumbnail-l)] pointer-events-none',
          {
            'flex justify-center items-center bg-common-gray-3': isOpening,
          }
        )}
      >
        {isOpening && (
          <>
            <Loading size="s" />
            <span className="sr-only">{t('common:openFile.loading')}</span>
          </>
        )}
      </div>
    </div>
  )
}
